import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/compiler/src/core';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';

import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';

import { ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import { ImmidiateErrorStateMatcher } from './classes/error-state-matcher';

import { DialogComponent } from './services/dialog/dialog.component';
import { SnackBarComponent } from './services/snack-bar/snack-bar.component';

import { CopyableComponent } from './components/copyable/copyable.component';
import { PasswordComponent } from './components/password/password.component';
import { AccessPolicyComponent } from './components/access-policy/access-policy.component';
import { AutocompleteChipsComponent } from './components/autocomplete-chips/autocomplete-chips.component';

import { HttpService } from './services/http.service';
import { DialogService } from './services/dialog.service';
import { AuthService } from './services/auth/auth.service';
import { BackgroundService } from './services/background.service';
import { SudoModeService } from './services/sudo-mode.service';
import { GoogleRecaptchaService } from './services/google-recaptcha.service';
import { SignalrService } from './services/signalr.service';
import { MonthPickerComponent } from './services/dialog/month-picker/month-picker.component';
import { getHebrewPaginatorIntl } from './pagination-translator.service';

const exports = [
  CommonModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,

  LoadingBarHttpClientModule,

  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCheckboxModule,
  MatRadioModule,
  MatProgressBarModule,
  MatListModule,
  MatIconModule,
  MatMenuModule,
  MatExpansionModule,
  MatTooltipModule,
  MatTableModule,
  MatSelectModule,
  MatPaginatorModule,
  MatSnackBarModule,
  ClipboardModule,
  ColorPickerModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCardModule
];

@NgModule({
  declarations: [
    DialogComponent,
    SnackBarComponent,
    CopyableComponent,
    PasswordComponent,
    AccessPolicyComponent,
    AutocompleteChipsComponent,
    MonthPickerComponent
  ],
  imports: [...exports],
  exports: [CopyableComponent, PasswordComponent, AccessPolicyComponent, AutocompleteChipsComponent, ...exports],
  entryComponents: [DialogComponent, SnackBarComponent]
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        HttpService,
        DialogService,
        AuthService,
        BackgroundService,
        SudoModeService,
        GoogleRecaptchaService,
        SignalrService,

        { provide: ErrorStateMatcher, useClass: ImmidiateErrorStateMatcher },
        { provide: MatPaginatorIntl, useValue: getHebrewPaginatorIntl() }
      ]
    };
  }
}
